var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCornerRamadan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-label": "Ramazan Yar\\u0131\\u015Fmas\\u0131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rm-face",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4A6BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1F3279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101A47"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rm-inner",
    cx: 0.42,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2E4BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121D52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rm-gloss",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rm-gold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF0A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7C843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C98A0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rm-glow",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF6C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFC94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F08A0C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "rm-m"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232,
    cy: 262,
    r: 112,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 232,
    r: 96,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rm-bsh",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rm-osh",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "170%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 8,
    floodColor: "#04081F",
    floodOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rm-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 250) scale(0.9) translate(-256 -256)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 16)",
    fill: "#04081F",
    opacity: 0.45,
    filter: "url(#rm-bsh)",
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 8)",
    fill: "#B07A0A",
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#rm-face)",
    stroke: "url(#rm-gold)",
    strokeWidth: 7,
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 178,
    fill: "#070D2E",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 252,
    r: 174,
    fill: "url(#rm-inner)",
    stroke: "#F7C843",
    strokeOpacity: 0.75,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 152,
    r: 3.5,
    fill: "#FFFFFF",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 296,
    r: 3,
    fill: "#FFFFFF",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 372,
    r: 2.5,
    fill: "#FFFFFF",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 236,
    r: 2,
    fill: "#FFFFFF",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rm-clip)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 118,
    rx: 210,
    ry: 112,
    fill: "url(#rm-gloss)",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#rm-osh)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    fill: "#9A6406",
    mask: "url(#rm-m)",
    transform: "translate(0 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    fill: "url(#rm-gold)",
    mask: "url(#rm-m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.4,219.7 A100,100 0 0 0 155.4,326.3",
    fill: "none",
    stroke: "#FFFFFF",
    strokeOpacity: 0.6,
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 5)",
    fill: "#9A6406",
    d: "M342.0,150.0 L352.0,176.2 L380.0,177.6 L358.2,195.3 L365.5,222.4 L342.0,207.0 L318.5,222.4 L325.8,195.3 L304.0,177.6 L332.0,176.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#rm-gold)",
    stroke: "#FFF3B8",
    strokeWidth: 2,
    strokeLinejoin: "round",
    d: "M342.0,150.0 L352.0,176.2 L380.0,177.6 L358.2,195.3 L365.5,222.4 L342.0,207.0 L318.5,222.4 L325.8,195.3 L304.0,177.6 L332.0,176.2 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 244,
    r: 6,
    fill: "none",
    stroke: "#F7C843",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 249,
    width: 24,
    height: 12,
    rx: 3,
    fill: "url(#rm-gold)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,261 L318,261 L326,284 L318,308 L282,308 L274,284 Z",
    fill: "url(#rm-gold)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,267 L311,267 L317,284 L311,302 L289,302 L283,284 Z",
    fill: "url(#rm-glow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,267 L300,302",
    stroke: "#C98A0B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 308,
    width: 24,
    height: 9,
    rx: 3,
    fill: "#C98A0B"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(404 168) scale(13)",
    fill: "#FFF6C9",
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(140 400) scale(10)",
    fill: "#FFF6C9",
    opacity: 0.85,
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerRamadan);
export default __webpack_public_path__ + "static/media/corner-ramadan.cce1f3a6bbecb81e48724751ef2ad136.svg";
export { ForwardRef as ReactComponent };